import { h, type FunctionalComponent } from '@stencil/core';
import { getAppName } from '../utils/utils';
import type {IDashboardDesktopView} from '../dashboard-views/dashboard-desktop-view';

type CtaPublicWidgetsRowProps = Pick<IDashboardDesktopView, 'country' | 'language' | 'hasCtaProductSelector' | 'hasSupportButton' | 'tabName' | 'analyticsTabName' | 'brand' | 'rtl' | 'productNaCountrySelectorLocales' >;

export const CtaPublicWidgetsRow: FunctionalComponent<CtaPublicWidgetsRowProps> = (
  props
) => {
    const {
      country,
      language,
      tabName,
      analyticsTabName,
      brand,
      hasCtaProductSelector,
      hasSupportButton,
      productNaCountrySelectorLocales,
    } = props;

    const targetBrand = getAppName(brand);

    return (

      (hasCtaProductSelector || hasSupportButton) &&
      <div class="cta-public-widgets-row">
        {hasCtaProductSelector && !productNaCountrySelectorLocales && <div class="cta-product-selector-container widget-offset-bottom">
          <uiaas-search-widget-cta-product-selector
            app-name={targetBrand}
            country={country}
            language={language}
            is-dashboard-view={true}
            dashboard-tab-name={tabName}
            analytics-tab-name={analyticsTabName}
          />
        </div>}
        <div class="cta-product-selector-container widget-offset-bottom">
          {hasSupportButton && <uiaas-search-support-button
            app-name={targetBrand}
            country={country}
            language={language}
            is-dashboard-view="true"
            dashboard-tab-name={tabName}
            analytics-tab-name={analyticsTabName}
          />}
        </div>
      </div>
    );
};
